"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectValuesById = exports.selectStructure = exports.selectHtgHxEntities = exports.selectHasData = exports.selectEquipmentIds = exports.selectDevicesById = exports.selectDeviceIds = exports.selectBuildings = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _constants = require("../../../utils/constants");
const selectStructure = _ref => {
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref;
  return (devices === null || devices === void 0 ? void 0 : devices.structure) || [];
};
exports.selectStructure = selectStructure;
const selectBuildings = _ref2 => {
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref2;
  return (devices === null || devices === void 0 ? void 0 : devices.buildings) || [];
};
exports.selectBuildings = selectBuildings;
const selectDevicesById = _ref3 => {
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref3;
  return (devices === null || devices === void 0 ? void 0 : devices.devices.byId) || {};
};
exports.selectDevicesById = selectDevicesById;
const selectValuesById = _ref4 => {
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref4;
  return (devices === null || devices === void 0 ? void 0 : devices.values.byId) || {};
};
exports.selectValuesById = selectValuesById;
const selectDeviceIds = _ref5 => {
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref5;
  return (devices === null || devices === void 0 ? void 0 : devices.devicePDIDs) || [];
};
exports.selectDeviceIds = selectDeviceIds;
const selectEquipmentIds = _ref6 => {
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref6;
  return (devices === null || devices === void 0 ? void 0 : devices.equipmentIds) || [];
};
exports.selectEquipmentIds = selectEquipmentIds;
const selectHasData = _ref7 => {
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref7;
  return (devices === null || devices === void 0 ? void 0 : devices.hasData) || false;
};
exports.selectHasData = selectHasData;
const selectHtgHxEntities = _ref8 => {
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref8;
  return (devices === null || devices === void 0 ? void 0 : devices.htgHxEntities) || {};
};
exports.selectHtgHxEntities = selectHtgHxEntities;